import { api } from '@/services';
import type {
  SolicitarRecuperacaoSenhaApi,
  ValidarTokenSenhaApi,
  RedefinirSenhaApi,
  ReenviarConviteApi,
  AuthStatusResponse,
} from '../types';

/**
 * As três primeiras são chamadas ANÔNIMAS (`[AllowAnonymous]` no
 * `AuthController`) — funcionam mesmo sem sessão, é o próprio propósito do
 * fluxo. `reenviarConvite` exige o admin já logado (`Usuario/ReenviarConvite`
 * herda a política `ItWorksUser` do `UsuariosController`).
 */

export const solicitarRecuperacaoSenha = (model: SolicitarRecuperacaoSenhaApi) =>
  api.post<AuthStatusResponse, SolicitarRecuperacaoSenhaApi>('Auth/EsqueciSenha', model);

export const validarTokenSenha = (model: ValidarTokenSenhaApi) =>
  api.post<AuthStatusResponse, ValidarTokenSenhaApi>('Auth/ValidarTokenSenha', model);

export const redefinirSenha = (model: RedefinirSenhaApi) =>
  api.post<AuthStatusResponse, RedefinirSenhaApi>('Auth/RedefinirSenha', model);

export const reenviarConvite = (model: ReenviarConviteApi) =>
  api.post<AuthStatusResponse, ReenviarConviteApi>('Usuario/ReenviarConvite', model);
